import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationResetPasswordArgs, BackendUserAuthStatus } from 'src/types/backend';

const MUTATION = gql`
  mutation ResetPassword($resetToken: String!, $newPassword: String!) {
    resetPassword(resetToken: $resetToken, newPassword: $newPassword) {
      token
    }
  }
`;

type Variables = BackendMutationResetPasswordArgs;
type Result = BackendUserAuthStatus;

export const resetPassword = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
